// Este archivo se compila automáticamente con Webpack, junto con cualquier otro archivo
// presente en este directorio. Se recomienda colocar tu lógica de aplicación real en
// una estructura relevante dentro de app/javascript y usar estos archivos pack solo para referenciar
// ese código para que se compile.

require("bootstrap");
const Rails = require("@rails/ujs");
// const Turbolinks = require("turbolinks");
const ActiveStorage = require("@rails/activestorage");
require("channels");
require("trix");
require("@rails/actiontext");
const cronstrue = require('cronstrue/i18n');
const ChartLib = require('chart.js/auto');
const Chart = ChartLib.default || ChartLib;

const {
  showMessage,
  showError,
  showSuccess,
  showInfo,
  call_api
} = require("./custom/globalFunctions");

Rails.start();
ActiveStorage.start();

require("trix");
require("@rails/actiontext");
require("jquery");

window.showInfo = showInfo;
window.showError = showError;
window.showSuccess = showSuccess;
window.showMessage = showMessage;
window.call_api = call_api;
window.cronstrue = cronstrue;
window.Chart = Chart;
